<template>
  <div :style="`width:${dispW}px; height:${dispH}px;color:white;`">
    <el-container style="line-height: 0px; width: 100%">
      <transition name="slide-fade">
        <ImgBox v-if="isLargImgVisible" :url="largeImgUrl" :dispW="dispW - 500" :dispH="dispH" />
      </transition>
      <el-container
        v-loading="loading"
        :element-loading-text="$t('langcfg.txtLoading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.5)"
      >
        <el-main :height="`${dispH - 80}px`">
          <MapForm
            v-model="loading"
            :dispW="dispW - 500"
            v-if="subPage === TOPOGRAPHYMODES.largemap.key"
            :dispH="dispH - menuH"
            :parentForm="TOPOGRAPHYMODES.largemap.key"
            :indexInForm="0"
            :index="0"
            :rightsider="TOPOGRAPHYMODES.largemap.rightsider"
            :casePath="casePath"
            :mapValues="mapValues"
            :eyeType="currentEye"
            @hide-waiting="hideWaiting"
          ></MapForm>
          <FourMaps
            v-model="loading"
            v-if="subPage === TOPOGRAPHYMODES.fourmaps.key"
            :dispW="dispW - 500"
            :dispH="dispH - menuH"
            :rightsider="TOPOGRAPHYMODES.fourmaps.rightsider"
            :mapValues="mapValues"
            :eyeType="currentEye"
            @hide-waiting="hideWaiting"
          ></FourMaps>
          <MainMeridian
            v-model="loading"
            v-if="subPage === TOPOGRAPHYMODES.factorforms.key"
            :dispW="dispW - 500"
            :dispH="dispH - menuH"
            :rightsider="TOPOGRAPHYMODES.factorforms.rightsider"
            :mapValues="mapValues"
            :eyeType="currentEye"
            @hide-waiting="hideWaiting"
          ></MainMeridian>
          <Zernike
            v-model="loading"
            v-if="subPage === TOPOGRAPHYMODES.zernike.key"
            :dispW="dispW - 450"
            :dispH="dispH - menuH"
            :rightsider="TOPOGRAPHYMODES.zernike.rightsider"
            :mapValues="mapValues"
            :eyeType="currentEye"
            @hide-waiting="hideWaiting"
          ></Zernike>
          <!-- R2.0.000.000 版本使用 开始 -->
          <Keratoconus
            v-model="loading"
            v-if="subPage === TOPOGRAPHYMODES.keratoconus.key"
            :dispW="dispW - 500"
            :dispH="dispH - menuH"
            :rightsider="TOPOGRAPHYMODES.keratoconus.rightsider"
            :mapValues="mapValues"
            :eyeType="currentEye"
            @hide-waiting="hideWaiting"
          ></Keratoconus>
          <FourierAnalysis
            v-model="loading"
            v-if="subPage === TOPOGRAPHYMODES.fourieranalysis.key"
            :dispW="dispW"
            :dispH="dispH - menuH"
            :rightsider="TOPOGRAPHYMODES.fourieranalysis.rightsider"
            :mapValues="mapValues"
            :eyeType="currentEye"
            @hide-waiting="hideWaiting"
          ></FourierAnalysis>
          <!-- R2.0.000.000 版本使用 结束 -->
          <PupilCornea
            v-model="loading"
            v-if="subPage === TOPOGRAPHYMODES.pupilcorneadia.key"
            :dispW="dispW"
            :dispH="dispH - 90"
            :record="record"
            :currentEye="currentEye"
            :pupilCorneaMode="pupilCorneaMode"
            :currentPatient="currentPatient"
            :currentPupilCornea="currentPupilCornea"
            @update-record="updateRecord"
            @hide-waiting="hideWaiting"
            @show-capture="showCapture"
          ></PupilCornea>
          <RGP
            v-model="loading"
            v-if="subPage === TOPOGRAPHYMODES.contectlens.key"
            :dispW="dispW"
            :dispH="dispH - menuH"
            :record="record"
            :currentEye="currentEye"
            :mapValues="mapValues"
            @hide-waiting="hideWaiting"
          ></RGP>
          <Compare2Records
            v-model="loading"
            v-if="subPage === TOPOGRAPHYMODES.compare2records.key"
            :dispW="dispW"
            :dispH="dispH - menuH"
            :patient="currentPatient"
            :record="record"
            :rightsider="TOPOGRAPHYMODES.compare2records.rightsider"
            :eyeType="currentEye"
            @hide-waiting="hideWaiting"
          ></Compare2Records>

          <Report
            v-if="subPage === TOPOGRAPHYMODES.report.key"
            :patient="currentPatient"
            :checkDate="checkDate"
            :record="record"
            :mapValues="mapValues"
            :currentEye="currentEye"
            @show-waiting="showWaiting"
            @hide-waiting="hideWaiting"
          ></Report>
        </el-main>
        <el-aside
          v-if="TOPOGRAPHYMODES[subPage] && TOPOGRAPHYMODES[subPage].rightsider"
          width="500px"
          :height="`${dispH - 80}px`"
        >
          <div style="height: 5px"></div>
          <RightAsider
            :mapValues="mapValues"
            :rightsider="TOPOGRAPHYMODES[subPage] && TOPOGRAPHYMODES[subPage].rightsider"
            :dispH="dispH - 80"
            :qs="QS"
            :isQVisible="isQVisible"
            :subPage="subPage"
          ></RightAsider>
        </el-aside>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { FILES, MAJMEDIANMODES } from "./shared/consts";
import { Size, SubPageSize, Message } from "../mixins";
import { TOPOGRAPHYMODES } from "../shared/consts";
import { TOPOGRAPHYEVENTS } from "./shared/events";
import fileSys from "../fileoprators/fileSystem";
import { normalMapValues } from "./dataGetters/mapValues";
import Compare2Records from "./components/Compare2Records.vue";
import FourMaps from "./components/FourMaps.vue";
import Keratoconus from "./components/Keratoconus.vue";
import FourierAnalysis from "./components/FourierAnalysis.vue";
import MainMeridian from "./components/MainMeridian.vue";
import MapForm from "./components/MapForm.vue";
import RGP from "./components/RGP.vue";
import Zernike from "./components/Zernike.vue";
import PupilCornea from "./components/PupilCornea";
import RightAsider from "./components/RightAsider.vue";
import PrintViewer from "./pages/dialog-forms/PrintViewer";
import DataParams from "./dataGetters/params";
import ImgBox from "./components/ImgBox";
import print from "./js/Print";
import Report from "./components/Report.vue";
import { Topography3rd } from "./js/thirdparty";
import EVENTS from "../bus";
import { hasKey, logStdout } from "../shared/utils";
import { calcElevDiff } from "./js/calc4mmElevDiff";

let dataparams;
export default {
  name: "CornealTopography",
  data() {
    return {
      activeIndex: 0,
      isLoadingReport: false,
      elmainW: this.dispW - 500,
      isReady: false,
      pages: TOPOGRAPHYMODES,
      isPrintView: false,
      printSrc: "",
      isDataShowSettingVisible: false,
      mapValues: {},
      loading: false,
      QS: [{ color: "red", label: "txtFailed" }],
      isLargImgVisible: false,
      largeImgUrl: "",
      printUrl: "",
      TOPOGRAPHYMODES: TOPOGRAPHYMODES,
      data: {},
      menuH: 122,
      isQVisible: false
    };
  },
  mixins: [Size, SubPageSize, Message],
  created() {
    // 注意:此方法必须在mounted之前调用
    this.$store.state.topography.casePath = this.casePath;
    dataparams = new DataParams(this.casePath);
    dataparams.getQS();
    this.QS = dataparams.QS;
    this.isQVisible = dataparams.isQVisible;

    let eyetype = this.currentEye;
    let set = this.dataShowSettings;
    this.mapValues = normalMapValues(dataparams, eyetype, set.medianMode, set.mm);
  },
  mounted: function () {
    this.$bus.$on(TOPOGRAPHYEVENTS.medianModeChanged, () => {
      dataparams.getMajMedian(this.dataShowSettings.medianMode);
      this.mapValues.params.EccPEQ.value = dataparams.getOneMajMedian(this.dataShowSettings.mm);
      let objDiff = calcElevDiff(
        this.casePath,
        this.mapValues.params.AxisFlat.value,
        this.mapValues.params.AxisSteep.value
      );
      this.mapValues.params.elevDiff4mm.value = objDiff.val;
      this.mapValues.params.elevDiff4mm.analog = objDiff.analog;
      this.mapValues.majMedian = dataparams.majMedian;
    });
    this.$bus.$on(TOPOGRAPHYEVENTS.showLargeImg, (showEdge, paramChanged) => {
      let edgeImgPath = fileSys.combinePath(
        this.$store.state.topography.casePath,
        FILES.edgeImgPath
      );
      let originImgPath = fileSys.combinePath(
        this.$store.state.topography.casePath,
        FILES.originImage
      );
      let url = "file://" + (showEdge ? edgeImgPath : originImgPath);
      let edgeImgExists = fileSys.isFileExists(edgeImgPath);
      if (showEdge && !edgeImgExists) {
        this.largeImgUrl = `file://${originImgPath}?${Math.random()}`;
      } else {
        this.largeImgUrl = `${url}?${Math.random()}`;
      }
      if (!paramChanged) {
        this.isLargImgVisible = !this.isLargImgVisible;
      }
    });
    this.uploadThirdParty();
  },
  beforeDestroy() {
    window.inspectId = undefined;
    dataparams = null;
    this.$bus.$off(TOPOGRAPHYEVENTS.medianModeChanged);
    this.$bus.$off(TOPOGRAPHYEVENTS.showLargeImg);
  },
  destroyed() {
    this.$destroy();
  },
  watch: {
    subPage: function (val) {
      this.isLargImgVisible = false;
    },
    currentEye: function (val) {
      let set = this.dataShowSettings;
      dataparams = new DataParams(this.casePath);
      this.mapValues = normalMapValues(dataparams, val, set.medianMode, set.mm);
    }
  },
  props: {
    pupilCorneaMode: {
      type: String,
      default: "pupildia"
    },
    currentPatient: {
      type: Object
    },
    subPage: {
      type: String,
      default: "largemap"
    },
    record: {
      default: function () {
        return {};
      }
    },
    casePath: {
      type: String,
      default: ""
    },
    currentEye: {
      type: String,
      default: ""
    },
    currentPupilCornea: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters(["dataShowSettings"]),
    checkDate: function () {
      return this.record.recorddate;
    }
  },
  components: {
    Compare2Records,
    FourMaps,
    Keratoconus,
    FourierAnalysis,
    MainMeridian,
    MapForm,
    RGP,
    Zernike,
    RightAsider,
    PrintViewer,
    ImgBox,
    PupilCornea,
    Report
    // Calibration
  },
  methods: {
    uploadThirdParty() {
      if (
        window.thirdPartySettings &&
        window.thirdPartySettings.auto &&
        window.thirdPartySettings.auto.value &&
        window.thirdpartyScript &&
        this.currentPatient.thirdData &&
        window.settings.thirdparty.copmany !== "owl"
      ) {
        if (
          !hasKey(this.record.content, `data${this.currentEye}.topography`) ||
          this.record.content[`data${this.currentEye}`]["topography"].uploaded
        )
          return;
        let topography3rd = new Topography3rd(
          this.currentPatient,
          this.record,
          this.$store.state.topography.casePath,
          this.currentEye
        );
        this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtLoading"), 20 * 1000);
        let { frontpValOfMajMeridians, isShowGrayF } = this.mapValues;
        let eccAll = dataparams.getMajMedianWithoutGray(
          frontpValOfMajMeridians,
          isShowGrayF,
          this.mapValues.params["AxisFlat"].value,
          MAJMEDIANMODES.ecc
        );
        let flatE6mm =
          eccAll[4].nas && eccAll[4].temp
            ? (Number(eccAll[4].nas.toFixed(2)) + Number(eccAll[4].temp.toFixed(2))) / 2
            : "--";
        let steepE6mm =
          eccAll[4].inf && eccAll[4].sup
            ? (Number(eccAll[4].inf.toFixed(2)) + Number(eccAll[4].sup.toFixed(2))) / 2
            : "--";
        let flatE8mm =
          eccAll[6].nas && eccAll[6].temp
            ? (Number(eccAll[6].nas.toFixed(2)) + Number(eccAll[6].temp.toFixed(2))) / 2
            : "--";
        let steepE8mm =
          eccAll[6].inf && eccAll[6].sup
            ? (Number(eccAll[6].inf.toFixed(2)) + Number(eccAll[6].sup.toFixed(2))) / 2
            : "--";
        this.mapValues.params["flatE6mm"] = flatE6mm;
        this.mapValues.params["steepE6mm"] = steepE6mm;
        this.mapValues.params["flatE8mm"] = flatE8mm;
        this.mapValues.params["steepE8mm"] = steepE8mm;
        topography3rd.normalParamsData(this.mapValues.params, null, (error, params, images) => {
          if (error) {
            this.message("create params data failed", "error");
            this.$bus.$emit(EVENTS.hideGlobalWatting);
            return;
          }
          logStdout("start send pupilcornea data and images:", params, images);
          window.thirdpartyScript.sendTopgraphicDataAndImages(
            this.currentPatient,
            this.record,
            this.currentEye,
            {
              images,
              params
            },
            (res) => {
              this.$bus.$emit(EVENTS.hideGlobalWatting);
              this.message(
                `${res.message}${res.detail ? ":" + res.detail : ""}`,
                res.code === 200 ? "success" : "error"
              );
              if (res.code === 200) {
                this.record.content[`data${this.currentEye}`].inspectId = res.inspectId;
                this.record.content[`data${this.currentEye}`]["topography"].uploaded = true;
                this.updateRecord(this.record);
              }
            }
          );
        });
      } else if (
        window.thirdPartySettings &&
        window.thirdPartySettings.auto &&
        window.thirdPartySettings.auto.value &&
        window.thirdpartyScript &&
        this.currentPatient.customerId
      ) {
        if (
          !hasKey(this.record.content, `data${this.currentEye}.topography`) ||
          this.record.content[`data${this.currentEye}`]["topography"].uploaded
        )
          return;
        let topography3rd = new Topography3rd(
          this.currentPatient,
          this.record,
          this.$store.state.topography.casePath,
          this.currentEye
        );
        this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtLoading"), 20 * 1000);
        topography3rd.normalParamsData(this.mapValues.params, null, (error, params, images) => {
          if (error) {
            this.message("create params data failed", "error");
            this.$bus.$emit(EVENTS.hideGlobalWatting);
            return;
          }
          logStdout("start send pupilcornea data and images:", params, images);
          window.thirdpartyScript.addStudy(
            this.currentPatient,
            this.record,
            this.currentEye,
            {
              images,
              params
            },
            (res) => {
              this.$bus.$emit(EVENTS.hideGlobalWatting);
              this.message(`${res.message}`, res.status === 200 ? "success" : "error");
              if (res.code === 200) {
                // this.record.content[`data${this.currentEye}`].inspectId = res.inspectId
                this.record.content[`data${this.currentEye}`]["topography"].uploaded = true;
                this.updateRecord(this.record);
              }
            }
          );
        });
      }
    },
    showWaiting(...e) {
      this.$emit("show-waiting", ...e);
    },
    hideWaiting() {
      this.$emit("hide-waiting");
    },
    updateRecord(newrecord, callback) {
      this.$emit("update-record", newrecord, callback);
    },
    showCapture(mode) {
      this.$emit("show-capture", "topography", mode);
    }
  }
};
</script>
<style scoped>
.el-header {
  background-color: #44444c;
  color: white;
  text-align: center;
  line-height: 80px;
  padding: 0px;
}
.el-aside {
  color: white;
  text-align: center;
  border: 1px solid gray;
}

.el-table {
  background-color: #44444c;
}
.el-table .defalut {
  background: #44444c;
}
.el-table .current {
  background: #4b505a;
}
.el-aside {
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.3, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active 用于 2.1.8 以下版本 */ {
  transform: translateX(10px);
  opacity: 0;
}
.btn-report {
  color: white;
  border: none;
  float: left;
  outline: none;
  background: transparent;
  font-size: 35px;
  height: 80px;
  cursor: pointer;
  padding: 0 20px 0 20px;
}
.btn-report:hover {
  background: rgb(51, 54, 61);
}
</style>



// WEBPACK FOOTER //
// src/topography/Topography.vue